// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
  box-sizing: border-box;
} */
/* html,
body {
  margin: 0;
  padding: 0;
} */
/* 
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
} */
/* 
header.header {
  display: flex;
  align-items: center;
  z-index: 99;
  padding-top: 56px;
  width: 100%;
  padding: 10px;
  background: #222f3f;
} */
/* header.header .is-logo {
  float: left;
  margin-right: 12px;
} */
/* 
header.header .logo {
  display: block;
} */
aside,
.results-wrapper {
  padding: 10px; }

.thank-you {
  font-size: 12px;
  text-align: center;
  margin-top: 20px; }

.ais-Panel {
  margin-top: 20px; }

.sort-by {
  display: flex;
  align-items: center; }

.sort-by label {
  margin-right: 5px; }

footer {
  margin-top: 25px; }

.results-wrapper {
  width: 100%; }

.no-results {
  text-align: center; }

.no-results .query {
  font-style: italic; }

.ais-RefinementList-list,
.ais-Hits-list,
.ais-Pagination-list {
  list-style-type: none;
  padding-left: 0; }

.ais-Pagination-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center; }

.ais-Pagination-list li span,
.ais-Pagination-list li a {
  display: inline-block;
  padding: 15px;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }

.ais-Pagination-list li:not(:first-child) span,
.ais-Pagination-list li:not(:first-child) a {
  /* border-left: 0; */
  margin-left: -1px; }

.ais-Pagination-list li span:hover,
.ais-Pagination-list li a:hover {
  background-color: #e9ecef;
  border-color: #dee2e6; }

.ais-Hits-list li {
  padding: 10px 0px; }

.product-title .ais-Highlight-nonHighlighted {
  font-weight: 700; }
`, "",{"version":3,"sources":["webpack://./src/views/post/search.scss"],"names":[],"mappings":"AAAA;;GAEG;AAEH;;;;GAGG;AAEH;;;;GAGG;AAEH;;;;;;;;;GAQG;AAGH;;;GACG;AAGH;;;GACG;AAIH;;EAEE,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB,EAAA;;AAGlB;EACE,WAAW,EAAA;;AAGb;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAGpB;;;EAGE,qBAAqB;EACrB,eAAe,EAAA;;AAGjB;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;;EAEE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,qIAC8D,EAAA;;AAGhE;;EAEE,oBAAA;EACA,iBAAiB,EAAA;;AAGnB;;EAEE,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB,EAAA","sourcesContent":["/* * {\n  box-sizing: border-box;\n} */\n\n/* html,\nbody {\n  margin: 0;\n  padding: 0;\n} */\n/* \nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,\n    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n} */\n/* \nheader.header {\n  display: flex;\n  align-items: center;\n  z-index: 99;\n  padding-top: 56px;\n  width: 100%;\n  padding: 10px;\n  background: #222f3f;\n} */\n\n/* header.header .is-logo {\n  float: left;\n  margin-right: 12px;\n} */\n/* \nheader.header .logo {\n  display: block;\n} */\n\naside,\n.results-wrapper {\n  padding: 10px;\n}\n\n.thank-you {\n  font-size: 12px;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.ais-Panel {\n  margin-top: 20px;\n}\n\n.sort-by {\n  display: flex;\n  align-items: center;\n}\n\n.sort-by label {\n  margin-right: 5px;\n}\n\nfooter {\n  margin-top: 25px;\n}\n\n.results-wrapper {\n  width: 100%;\n}\n\n.no-results {\n  text-align: center;\n}\n\n.no-results .query {\n  font-style: italic;\n}\n\n.ais-RefinementList-list,\n.ais-Hits-list,\n.ais-Pagination-list {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.ais-Pagination-list {\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.ais-Pagination-list li span,\n.ais-Pagination-list li a {\n  display: inline-block;\n  padding: 15px;\n  border: 1px solid #dee2e6;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.ais-Pagination-list li:not(:first-child) span,\n.ais-Pagination-list li:not(:first-child) a {\n  /* border-left: 0; */\n  margin-left: -1px;\n}\n\n.ais-Pagination-list li span:hover,\n.ais-Pagination-list li a:hover {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.ais-Hits-list li {\n  padding: 10px 0px;\n}\n\n.product-title .ais-Highlight-nonHighlighted {\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
